import { environment } from "./environments/environment";

export const config = {
  apiUrl: environment.production
    ? "https://api.nox-xtreme.com"
    : "http://localhost:5003",
  webUrl: environment.production
    ? "https://www.nox-xtreme.com"
    : "http://localhost:9000",
  authTokenName: "token",

  defaultLocaleCode: "es",
  localesAvailable: [
    { code: "es", name: "Español" },
    { code: "en", name: "Inglés" },
    { code: "pt", name: "Portugués" },
  ],

  cmsName: "Nox Xtreme",
  topBarLogo: "/assets/images/logo.svg",
  topBarLogoHeight: "36px",

  store: "http://store.nox-xtreme.com",

  modules: {
    product: {
      videos: {
        title: true,
        backgroundMobile: true,
      },
    },
    common: {
      slide: {
        textBackground: {
          default: "gray",
          options: [
            { value: "none", label: "Sin fondo" },
            { value: "background", label: "Con fondo" },
          ],
        },
        backgroundSchema: false,
        backgroundColorSecondary: true,
        backgroundColorOptions: [
          { value: "white", label: "Blanco" },
          { value: "white_gray", label: "Blanco + Gris" },
          { value: "gray", label: "Gris" },
          { value: "gray_white", label: "Gris + Blanco" },
          { value: "custom", label: "Personalizado" },
        ],
      },
    },
    home: {
      slider: {
        image: true,
        imageMobile: true,
        subtitle: true,
      },
    },
  },

  mainMenuSections: [
    {
      name: "Dashboard",
      description: "Indice con información general",
      icon: "assignment ind",
      url: "",
    },
    {
      name: "Administradores",
      description: "Gestion de administradores del panel",
      icon: "person",
      url: "administrators",
    },
    {
      name: "Categorias",
      description: "Gestion de los categorias de un producto",
      icon: "group_work",
      url: "categories",
    },
    {
      name: "Departamentos",
      description: "Gestion de los departamentos",
      icon: "event_seat",
      url: "departments",
    },
    {
      name: "Descargas",
      description: "Gestion de los descargas generales",
      icon: "star",
      url: "downloads",
    },
    {
      name: "Diapositivas ESports",
      description: "Gestion de las diapositivas de ESports",
      icon: "group",
      url: "esports-slides",
    },
    {
      name: "Distribuidores",
      description: "Gestion de distribuidores y tiendas",
      icon: "store",
      url: "resellers",
    },
    {
      name: "Equipos ESports",
      description: "Gestion de los equipos ESports",
      icon: "group",
      url: "esports-teams",
    },
    {
      name: "Filtros",
      description: "Filtros que pueden tener los productos",
      icon: "details",
      url: "filters",
    },
    {
      name: "Home Slider",
      description: "Gestion del Home Slider",
      icon: "burst_mode",
      url: "home-slider",
    },
    {
      name: "Landings",
      description: "Gestion de los landings",
      icon: "view_compact",
      url: "landings",
    },
    {
      name: "Páginas",
      description: "Gestion de páginas",
      icon: "label",
      url: "pages",
    },
    {
      name: "Paises",
      description: "Gestion de paises",
      icon: "public",
      url: "countries",
    },
    {
      name: "Premios",
      description: "Premios que puede ganar un producto",
      icon: "bookmark",
      url: "awards",
    },
    {
      name: "Productos",
      description: "Gestion de los productos",
      icon: "headset",
      url: "products",
    },
    {
      name: "Series",
      description: "Gestion de las series de un producto",
      icon: "label",
      url: "series",
    },
    {
      name: "Tipos de Descarga",
      description: "Tipos de descarga que puede ofrecer un producto",
      icon: "cloud_download",
      url: "download-types",
    },
  ],
};



// WEBPACK FOOTER //
// ./apps/nox/src/config.ts